module.exports = __webpack_public_path__ + "static/media/city-banner.9b183864.jpg";